module.exports = __webpack_public_path__ + "static/media/6.cbfac361.jpg";